import React from 'react';
import { useTheme } from '../../contexts/ThemeContext.jsx';

/**
 * AdminNavigation component providing theme-aware tab navigation for admin dashboard
 * Implements consistent styling with user dashboard patterns
 */
const AdminNavigation = ({ activeTab, setActiveTab, tabs }) => {
  const { theme } = useTheme();
  
  return (
    <div 
      className={`${theme === 'dark' ? 'bg-gray-800 border-gray-700' : 'bg-white border-gray-200'} border-b rounded-t-lg`}
      data-testid="admin-navigation"
    >
      <div className="px-6">
        <nav 
          className="flex space-x-8" 
          role="tablist"
          aria-label="Admin navigation tabs"
        >
          {tabs.map((tab) => (
            <button
              key={tab.id}
              onClick={() => setActiveTab(tab.id)}
              role="tab"
              aria-selected={activeTab === tab.id}
              aria-controls={`${tab.id}-panel`}
              title={`Switch to ${tab.name} tab`}
              className={`py-4 px-1 border-b-2 font-medium text-sm transition-colors focus:outline-none focus:ring-2 focus:ring-teal-500 focus:ring-offset-2 ${
                activeTab === tab.id
                  ? `border-teal-500 ${theme === 'dark' ? 'text-teal-400' : 'text-teal-600'}`
                  : `border-transparent ${
                      theme === 'dark' 
                        ? 'text-gray-400 hover:text-gray-200 hover:border-gray-600' 
                        : 'text-gray-500 hover:text-gray-700 hover:border-gray-300'
                    }`
              }`}
              data-testid={`admin-tab-${tab.id}`}
            >
              <span className="mr-2" aria-hidden="true">{tab.icon || ''}</span>
              {tab.name}
            </button>
          ))}
        </nav>
      </div>
    </div>
  );
};

export default AdminNavigation;
